export const I18_NAMESPACES_MBS_UI_KIT = ['mbs-ui-kit'];

export const I18_NAMESPACES_MBS_UI_SHARED = ['shared'];

export const I18_NAMESPACES_MBS_UI = ['mbs-ui'];

export const I18_NAMESPACES_MBS_UI_WIZARDS = ['wizards'];

export const I18_NAMESPACES_MBS_WEB_CONNECT = ['webrtc'];

export const I18_NAMESPACES_ONLINE_ACCESS = ['online-access'];

export const I18_NAMESPACES_MBS_RESELLER = ['mbs-reseller'];

export enum I18_NAMESPACE_APPS_UI {
  app = 'app',
  account = 'my-account.module',
  audit = 'audit.module',
  backupHistory = 'backup-history.module',
  button = 'button',
  calendar = 'calendar.module',
  chart = 'chart.module',
  contacts = 'contacts.module',
  dashboard = 'dashboard.module',
  dontHavePermission = 'dont-have-permission.module',
  drive = 'drive.module', // base module for Drive, SharePoint, Shared Drives, Teams pages
  history = 'history.module',
  mail = 'mail.module',
  payments = 'payments.module',
  policy = 'retention-policy.module',
  reports = 'reports.module',
  results = 'export-results.module',
  skipItems = 'skipped-items-history.module',
  tasks = 'task-manager.module',
  users = 'users.module'
}

export const I18_NAMESPACES_APPS_UI = [
  I18_NAMESPACE_APPS_UI.account,
  I18_NAMESPACE_APPS_UI.button,
  I18_NAMESPACE_APPS_UI.dontHavePermission,
  I18_NAMESPACE_APPS_UI.policy,
  I18_NAMESPACE_APPS_UI.app
];
